import { formatDate } from '@angular/common';

export function formatRequestDate(date: string, locale: string): string {
  return formatDate(date, 'yyyy-MM-dd', locale);
}
